import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import Comments from '../../shared/comments';

import style from './index.module.scss';

const {
  questionMutations: { QUESTION_ACTIONS_UPDATE },
} = mutations;

const shareIcons = [
  {
    name: 'fas fa-chevron-down',
    label: '',
  },
  {
    name: 'fab fa-facebook',
    label: '',
  },
  {
    name: 'fab fa-twitter',
    label: '',
  },
  {
    name: 'fas fa-share',
    label: '',
  },
];

function Icon({ icon, actionStyle, iconStyle, displayAnswerForm }) {
  return (
    <span
      className={actionStyle}
      onClick={icon.label === 'Answer' ? displayAnswerForm : null}
    >
      <i className={`${icon.name} ${iconStyle}`} /> {icon.label && icon.label}
    </span>
  );
}

const renderTopicTags = topicList => {
  if (topicList.length <= 3) {
    return (
      <>
        {topicList.map((topic, index) => (
          <Link
            to={`/topic/${topic}`}
            key={index}
            className={style['topic-tag']}
          >
            {topic}
          </Link>
        ))}
      </>
    );
  } else {
    return (
      <>
        {topicList.slice(0, 3).map((topic, index) => (
          <Link
            to={`/topic/${topic}`}
            key={index}
            className={style['topic-tag']}
          >
            {topic}
          </Link>
        ))}
        <span className={style['topic-tag']}>+{topicList.slice(3).length}</span>
        <span>
          <i className={`fas fa-pen`} />
        </span>
      </>
    );
  }
};

function QuestionHeader({ question, displayAnswerForm }) {
  const { currentUser } = useContext(AuthContext);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const { col, action, actions, share } = style;

  const toggleCommentSection = () => setShowCommentSection(!showCommentSection);

  return (
    <>
      <div className={`col ${col} ${style['col--tags']}`}>
        {renderTopicTags(question.topics)}
      </div>
      <h2 className={style['question-title']}>{question.title}</h2>
      <div className={`col ${col} ${style['col--actions']}`}>
        <div className={actions}>
          <span
            className={`${action} ${style['action--answer']}`}
            onClick={displayAnswerForm}
          >
            <i className={`far fa-edit ${style.icon}`} /> Answer
          </span>
          <Mutation mutation={QUESTION_ACTIONS_UPDATE}>
            {(questionActionsUpdate, { loading, error, data }) => (
              <span
                className={action}
                onClick={() =>
                  questionActionsUpdate({
                    variables: {
                      input: {
                        questionId: question.id,
                        userId: currentUser.id,
                        updateType: 'follow',
                      },
                    },
                  })
                }
              >
                <i className={`fas fa-rss ${style.icon}`} /> Follow
              </span>
            )}
          </Mutation>
          <span className={action}>
            <i className={`fas fa-user ${style.icon}`} /> Request
          </span>
        </div>
        <div className={share}>
          <span className={action} onClick={toggleCommentSection}>
            <i className={`far fa-comment ${style.icon}`} />{' '}
            {question.comments.length}
          </span>
          {shareIcons.map((icon, index) => (
            <Icon
              icon={icon}
              actionStyle={action}
              iconStyle={style.icon}
              key={index}
            />
          ))}
        </div>
      </div>
      {showCommentSection && (
        <div className={style['comments-section']}>
          <Comments questionId={question.id} commentList={question.comments} />
        </div>
      )}
    </>
  );
}

QuestionHeader.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    topics: PropTypes.array.isRequired,
    comments: PropTypes.array.isRequired,
  }).isRequired,
  displayAnswerForm: PropTypes.func.isRequired,
};

export default QuestionHeader;
